import { isEmpty, isUndefined } from 'lodash'
import { defaultExportMenu, getStackedSeries } from '../helpers'

export default ({ config, data, color, legendLabels = {} }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    labelsRotation = undefined,
    exportingMenu,
    disabledAnimations = false
  } = restConfig

  const keys = []

  if (!isEmpty(series)) {
    series.forEach((el) => {
      // get custom legend labels with translated values
      !isEmpty(legendLabels) &&
        Object.keys(legendLabels).forEach((key) => {
          if (el.includes(key)) {
            keys.push(legendLabels[key])
          }
        })
    })
  }

  const chartConfig = {
    data: data,
    autoDispose: true,
    type: 'XYChart',
    series: getStackedSeries({
      series,
      otherConfig: {
        legendLabel: keys,
        color,
        disabledAnimations,
        ...restConfig
      }
    }),
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    cursor: {},
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            rotation: !isUndefined(labelsRotation) ? labelsRotation : -60,
            verticalCenter: 'left',
            horizontalCenter: 'middle',
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor
        },
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3
          },
          labels: {
            fill: labelColor
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          },
          labels: {
            fill: labelColor
          }
        }
      }
    ],
    legend: {
      useDefaultMarker: true,
      labels: {
        text: '{name}',
        fill: labelColor
      },
      contentAlign: 'left',
      paddingTop: 10,
      paddingLeft: 45,
      markers: {
        children: [
          {
            width: 20,
            height: 20,
            fontSize: 200,
            strokeWidth: 0,
            paddingTop: 2.5,
            marginLeft: 22.5,
            paddingLeft: 2.5,
            strokeOpacity: 0,
            paddingRight: 2.5,
            paddingBottom: 2.5,
            cornerRadiusTopLeft: 0,
            cornerRadiusTopRight: 0,
            cornerRadiusBottomLeft: 0,
            cornerRadiusBottomRight: 0
          }
        ]
      }
    }
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }
  return chartConfig
}
